/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as ErrorRouteImport } from "./routes/error"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as AuthenticatedWidgetPreviewRouteImport } from "./routes/_authenticated/widget-preview"
import { Route as AuthenticatedSuperpowersRouteRouteImport } from "./routes/_authenticated/superpowers/route"
import { Route as AuthenticatedWebhooksIndexRouteImport } from "./routes/_authenticated/webhooks/index"
import { Route as AuthenticatedSuperpowersIndexRouteImport } from "./routes/_authenticated/superpowers/index"
import { Route as AuthenticatedLiveSummaryIndexRouteImport } from "./routes/_authenticated/live-summary/index"
import { Route as AuthenticatedBaseModulesIndexRouteImport } from "./routes/_authenticated/base-modules/index"
import { Route as AuthenticatedApiTokensIndexRouteImport } from "./routes/_authenticated/api-tokens/index"
import { Route as AuthenticatedSuperpowersNotFoundRouteImport } from "./routes/_authenticated/superpowers/NotFound"
import { Route as AuthenticatedSuperpowersUidIndexRouteImport } from "./routes/_authenticated/superpowers/$uid/index"

const ErrorRoute = ErrorRouteImport.update({
  id: "/error",
  path: "/error",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWidgetPreviewRoute =
  AuthenticatedWidgetPreviewRouteImport.update({
    id: "/widget-preview",
    path: "/widget-preview",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuperpowersRouteRoute =
  AuthenticatedSuperpowersRouteRouteImport.update({
    id: "/superpowers",
    path: "/superpowers",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebhooksIndexRoute =
  AuthenticatedWebhooksIndexRouteImport.update({
    id: "/webhooks/",
    path: "/webhooks/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuperpowersIndexRoute =
  AuthenticatedSuperpowersIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedSuperpowersRouteRoute,
  } as any)
const AuthenticatedLiveSummaryIndexRoute =
  AuthenticatedLiveSummaryIndexRouteImport.update({
    id: "/live-summary/",
    path: "/live-summary/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBaseModulesIndexRoute =
  AuthenticatedBaseModulesIndexRouteImport.update({
    id: "/base-modules/",
    path: "/base-modules/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApiTokensIndexRoute =
  AuthenticatedApiTokensIndexRouteImport.update({
    id: "/api-tokens/",
    path: "/api-tokens/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuperpowersNotFoundRoute =
  AuthenticatedSuperpowersNotFoundRouteImport.update({
    id: "/NotFound",
    path: "/NotFound",
    getParentRoute: () => AuthenticatedSuperpowersRouteRoute,
  } as any)
const AuthenticatedSuperpowersUidIndexRoute =
  AuthenticatedSuperpowersUidIndexRouteImport.update({
    id: "/$uid/",
    path: "/$uid/",
    getParentRoute: () => AuthenticatedSuperpowersRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedRouteWithChildren
  "/error": typeof ErrorRoute
  "/superpowers": typeof AuthenticatedSuperpowersRouteRouteWithChildren
  "/widget-preview": typeof AuthenticatedWidgetPreviewRoute
  "/superpowers/NotFound": typeof AuthenticatedSuperpowersNotFoundRoute
  "/api-tokens/": typeof AuthenticatedApiTokensIndexRoute
  "/base-modules/": typeof AuthenticatedBaseModulesIndexRoute
  "/live-summary/": typeof AuthenticatedLiveSummaryIndexRoute
  "/superpowers/": typeof AuthenticatedSuperpowersIndexRoute
  "/webhooks/": typeof AuthenticatedWebhooksIndexRoute
  "/superpowers/$uid/": typeof AuthenticatedSuperpowersUidIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof AuthenticatedRouteWithChildren
  "/error": typeof ErrorRoute
  "/widget-preview": typeof AuthenticatedWidgetPreviewRoute
  "/superpowers/NotFound": typeof AuthenticatedSuperpowersNotFoundRoute
  "/api-tokens": typeof AuthenticatedApiTokensIndexRoute
  "/base-modules": typeof AuthenticatedBaseModulesIndexRoute
  "/live-summary": typeof AuthenticatedLiveSummaryIndexRoute
  "/superpowers": typeof AuthenticatedSuperpowersIndexRoute
  "/webhooks": typeof AuthenticatedWebhooksIndexRoute
  "/superpowers/$uid": typeof AuthenticatedSuperpowersUidIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/error": typeof ErrorRoute
  "/_authenticated/superpowers": typeof AuthenticatedSuperpowersRouteRouteWithChildren
  "/_authenticated/widget-preview": typeof AuthenticatedWidgetPreviewRoute
  "/_authenticated/superpowers/NotFound": typeof AuthenticatedSuperpowersNotFoundRoute
  "/_authenticated/api-tokens/": typeof AuthenticatedApiTokensIndexRoute
  "/_authenticated/base-modules/": typeof AuthenticatedBaseModulesIndexRoute
  "/_authenticated/live-summary/": typeof AuthenticatedLiveSummaryIndexRoute
  "/_authenticated/superpowers/": typeof AuthenticatedSuperpowersIndexRoute
  "/_authenticated/webhooks/": typeof AuthenticatedWebhooksIndexRoute
  "/_authenticated/superpowers/$uid/": typeof AuthenticatedSuperpowersUidIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/error"
    | "/superpowers"
    | "/widget-preview"
    | "/superpowers/NotFound"
    | "/api-tokens/"
    | "/base-modules/"
    | "/live-summary/"
    | "/superpowers/"
    | "/webhooks/"
    | "/superpowers/$uid/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/error"
    | "/widget-preview"
    | "/superpowers/NotFound"
    | "/api-tokens"
    | "/base-modules"
    | "/live-summary"
    | "/superpowers"
    | "/webhooks"
    | "/superpowers/$uid"
  id:
    | "__root__"
    | "/_authenticated"
    | "/error"
    | "/_authenticated/superpowers"
    | "/_authenticated/widget-preview"
    | "/_authenticated/superpowers/NotFound"
    | "/_authenticated/api-tokens/"
    | "/_authenticated/base-modules/"
    | "/_authenticated/live-summary/"
    | "/_authenticated/superpowers/"
    | "/_authenticated/webhooks/"
    | "/_authenticated/superpowers/$uid/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ErrorRoute: typeof ErrorRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/error": {
      id: "/error"
      path: "/error"
      fullPath: "/error"
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/widget-preview": {
      id: "/_authenticated/widget-preview"
      path: "/widget-preview"
      fullPath: "/widget-preview"
      preLoaderRoute: typeof AuthenticatedWidgetPreviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/superpowers": {
      id: "/_authenticated/superpowers"
      path: "/superpowers"
      fullPath: "/superpowers"
      preLoaderRoute: typeof AuthenticatedSuperpowersRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/webhooks/": {
      id: "/_authenticated/webhooks/"
      path: "/webhooks"
      fullPath: "/webhooks/"
      preLoaderRoute: typeof AuthenticatedWebhooksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/superpowers/": {
      id: "/_authenticated/superpowers/"
      path: "/"
      fullPath: "/superpowers/"
      preLoaderRoute: typeof AuthenticatedSuperpowersIndexRouteImport
      parentRoute: typeof AuthenticatedSuperpowersRouteRoute
    }
    "/_authenticated/live-summary/": {
      id: "/_authenticated/live-summary/"
      path: "/live-summary"
      fullPath: "/live-summary/"
      preLoaderRoute: typeof AuthenticatedLiveSummaryIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/base-modules/": {
      id: "/_authenticated/base-modules/"
      path: "/base-modules"
      fullPath: "/base-modules/"
      preLoaderRoute: typeof AuthenticatedBaseModulesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/api-tokens/": {
      id: "/_authenticated/api-tokens/"
      path: "/api-tokens"
      fullPath: "/api-tokens/"
      preLoaderRoute: typeof AuthenticatedApiTokensIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/superpowers/NotFound": {
      id: "/_authenticated/superpowers/NotFound"
      path: "/NotFound"
      fullPath: "/superpowers/NotFound"
      preLoaderRoute: typeof AuthenticatedSuperpowersNotFoundRouteImport
      parentRoute: typeof AuthenticatedSuperpowersRouteRoute
    }
    "/_authenticated/superpowers/$uid/": {
      id: "/_authenticated/superpowers/$uid/"
      path: "/$uid"
      fullPath: "/superpowers/$uid/"
      preLoaderRoute: typeof AuthenticatedSuperpowersUidIndexRouteImport
      parentRoute: typeof AuthenticatedSuperpowersRouteRoute
    }
  }
}

interface AuthenticatedSuperpowersRouteRouteChildren {
  AuthenticatedSuperpowersNotFoundRoute: typeof AuthenticatedSuperpowersNotFoundRoute
  AuthenticatedSuperpowersIndexRoute: typeof AuthenticatedSuperpowersIndexRoute
  AuthenticatedSuperpowersUidIndexRoute: typeof AuthenticatedSuperpowersUidIndexRoute
}

const AuthenticatedSuperpowersRouteRouteChildren: AuthenticatedSuperpowersRouteRouteChildren =
  {
    AuthenticatedSuperpowersNotFoundRoute:
      AuthenticatedSuperpowersNotFoundRoute,
    AuthenticatedSuperpowersIndexRoute: AuthenticatedSuperpowersIndexRoute,
    AuthenticatedSuperpowersUidIndexRoute:
      AuthenticatedSuperpowersUidIndexRoute,
  }

const AuthenticatedSuperpowersRouteRouteWithChildren =
  AuthenticatedSuperpowersRouteRoute._addFileChildren(
    AuthenticatedSuperpowersRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedSuperpowersRouteRoute: typeof AuthenticatedSuperpowersRouteRouteWithChildren
  AuthenticatedWidgetPreviewRoute: typeof AuthenticatedWidgetPreviewRoute
  AuthenticatedApiTokensIndexRoute: typeof AuthenticatedApiTokensIndexRoute
  AuthenticatedBaseModulesIndexRoute: typeof AuthenticatedBaseModulesIndexRoute
  AuthenticatedLiveSummaryIndexRoute: typeof AuthenticatedLiveSummaryIndexRoute
  AuthenticatedWebhooksIndexRoute: typeof AuthenticatedWebhooksIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSuperpowersRouteRoute:
    AuthenticatedSuperpowersRouteRouteWithChildren,
  AuthenticatedWidgetPreviewRoute: AuthenticatedWidgetPreviewRoute,
  AuthenticatedApiTokensIndexRoute: AuthenticatedApiTokensIndexRoute,
  AuthenticatedBaseModulesIndexRoute: AuthenticatedBaseModulesIndexRoute,
  AuthenticatedLiveSummaryIndexRoute: AuthenticatedLiveSummaryIndexRoute,
  AuthenticatedWebhooksIndexRoute: AuthenticatedWebhooksIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ErrorRoute: ErrorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
